import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { track } from "@/lib/analytics";

const NAV = [
  { label: "MENU", id: "menu" },
  { label: "IL MORSO", id: "morso" },
  { label: "UNGRIP CLUB", id: "club" },
  { label: "DOVE SIAMO", id: "location" },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50" data-testid="site-header">
      <div className={`header-gradient transition-all duration-300 ${scrolled ? "py-2 shadow-[0_8px_30px_rgba(0,0,0,0.5)]" : "py-3 sm:py-4"}`}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 flex items-center justify-between gap-4">
          <button onClick={() => go("top")} className="flex items-center shrink-0" data-testid="header-logo" aria-label="UNGRIP home">
            <img
              src="/assets/10_logo_ungrip_header.png"
              alt="UNGRIP — MORDI LA VOGLIA"
              className={`w-auto transition-all duration-300 ${scrolled ? "h-9 sm:h-10" : "h-11 sm:h-14"}`}
            />
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="nav-underline font-display font-bold uppercase tracking-wide text-[15px] text-white/90 hover:text-white transition-colors"
                data-testid={`nav-${n.id}-link`}
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => { track("hero_cta_click", { cta: "header" }); go("menu"); }}
              className="hidden sm:inline-flex items-center rounded-full bg-[#0C0C0C] text-[#FFC20E] font-display font-extrabold uppercase tracking-wide text-sm px-5 py-2.5 border border-black hover:bg-[#FFC20E] hover:text-[#0C0C0C] transition-colors duration-200"
              data-testid="header-cta-button"
            >
              TI È PRESO UNGRIP?
            </button>
            <button
              className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full bg-[#0C0C0C] text-[#FFC20E]"
              onClick={() => setOpen((o) => !o)}
              aria-label="Apri menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden bg-[#0C0C0C] border-t border-[#242424] px-4 py-4"
            data-testid="mobile-menu-panel"
          >
            <div className="flex flex-col">
              {NAV.map((n) => (
                <button
                  key={n.id}
                  onClick={() => go(n.id)}
                  className="text-left font-display font-bold uppercase tracking-wide text-2xl text-white py-3 border-b border-[#1c1c1c]"
                  data-testid={`mobile-nav-${n.id}-link`}
                >
                  {n.label}
                </button>
              ))}
              <button
                onClick={() => go("menu")}
                className="mt-4 rounded-full bg-[#FFC20E] text-[#0C0C0C] font-display font-extrabold uppercase text-lg py-3"
                data-testid="mobile-header-cta"
              >
                TI È PRESO UNGRIP?
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
